import { Modal } from 'react-native';

import ClaimNpoCard from '../cards/ClaimNpoCard';
import ModalCard from './ModalCard';

interface ClaimNpoModalProps {
  npoName: string;
  visible: boolean;
  onClaimPressed: () => void;
  onCloseModal: () => void;
}

const ClaimNpoModal = ({ npoName, visible, onClaimPressed, onCloseModal }: ClaimNpoModalProps) => {
  return (
    <Modal animationType="fade" transparent={true} visible={visible} statusBarTranslucent onRequestClose={onCloseModal}>
      <ModalCard closeModal={onCloseModal} showCloseButton closeOnTapOutside>
        <ClaimNpoCard onButtonPress={onClaimPressed} npoName={npoName} />
      </ModalCard>
    </Modal>
  );
};

export default ClaimNpoModal;
